import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "floating-alert",
  templateUrl: "floating-alert.html",
})
export class FloatingAlertComponent {
  @Input() headerText: string;
  @Input() alertText: string;
  @Input() buttonText: string;

  @Output() clickButton = new EventEmitter<Object>();

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/common/alerts/floating-alert/floating-alert.ts